import * as extendActionType from 'reducers/extendActionType';

export const CREATE_PAID_SERVICE = 'paidServices/CREATE_PAID_SERVICE';
export const EDIT_PAID_SERVICE = 'paidServices/EDIT_PAID_SERVICE';
export const GET_PAID_SERVICES_LIST = 'paidServices/GET_PAID_SERVICES_LIST';
export const GET_ACTIVE_PAID_SERVICES_LIST = 'paidServices/GET_ACTIVE_PAID_SERVICES_LIST';
export const ACTIVATE_SERVICE = 'paidServices/ACTIVATE_SERVICE';
export const DEACTIVATE_SERVICE = 'paidServices/DEACTIVATE_SERVICE';
export const CREATE_PAID_SERVICE_DIALOG = 'paidServices/CREATE_PAID_SERVICE_DIALOG';
export const EDIT_PAID_SERVICE_DIALOG = 'paidServices/EDIT_PAID_SERVICE_DIALOG';
export const GET_PAID_SERVICES_FOR_HOME_PAGE = 'paidServices/GET_PAID_SERVICES_FOR_HOME_PAGE';
export const REQUEST_PAID_SERVICE = 'paidServices/REQUEST_PAID_SERVICE';
export const REQUEST_PAID_SERVICE_DIALOG = 'paidServices/REQUEST_PAID_SERVICE_DIALOG';
export const GET_PAID_SERVICES_FOR_DROPDOWN = 'paidServices/GET_PAID_SERVICES_FOR_DROPDOWN';
export const ADD_TO_HOMEPAGE = 'paidServices/ADD_TO_HOMEPAGE';
export const REMOVE_FROM_HOMEPAGE = 'paidServices/REMOVE_FROM_HOMEPAGE';

export const GET_MY_SETTINGS = 'paidServices/GET_MY_SETTINGS';
export const RESET_MY_SETTINGS = 'paidServices/RESET_MY_SETTINGS';
export const ENABLE_FOR_ME = 'paidServices/ENABLE_FOR_ME';
export const DISABLE_FOR_ME = 'paidServices/DISABLE_FOR_ME';
export const UPDATE_SETTINGS_ITEM = 'paidServices/UPDATE_SETTINGS_ITEM';

export function updateSettingsItem(itemToUpdate) {
    return {
        type: UPDATE_SETTINGS_ITEM,
        itemToUpdate,
    };
}

export function getMySettings() {
    return {
        type: GET_MY_SETTINGS,
        httpRequest: {
            method: 'get',
            path: '/paidServices/settings/me',
        },
    };
}

export function enableForMe(serviceId) {
    return {
        type: ENABLE_FOR_ME,
        httpRequest: {
            method: 'put',
            path: `/paidServices/${serviceId}/enable/for/me`,
        },
    };
}

export function disableForMe(serviceId) {
    return {
        type: DISABLE_FOR_ME,
        httpRequest: {
            method: 'put',
            path: `/paidServices/${serviceId}/disable/for/me`,
        },
    };
}

export function resetMySettings() {
    return {
        type: RESET_MY_SETTINGS,
        httpRequest: {
            method: 'put',
            path: '/paidServices/settings/reset/for/me',
        },
    };
}


export function createPaidService(data) {
    return {
        type: CREATE_PAID_SERVICE,
        httpRequest: {
            method: 'post',
            path: '/paidServices',
            data,
        },
    };
}

export function getDropdownPaidServices(search) {
    return {
        type: GET_PAID_SERVICES_FOR_DROPDOWN,
        httpRequest: {
            method: 'get',
            path: '/paidServices/dropdown',
            params: {
                search,
            },
        },
    };
}

export function requestPaidService(serviceId, doctorId, intakeFormAnswer, files, card, coupon) {
    return {
        type: REQUEST_PAID_SERVICE,
        httpRequest: {
            method: 'post',
            path: `/paidServices/request/${serviceId}`,
            data: {
                intakeFormAnswer,
                card,
                coupon,
                files,
                doctorId,
            },
        },
    };
}

export function editPaidService(serviceId, data) {
    return {
        type: EDIT_PAID_SERVICE,
        httpRequest: {
            method: 'put',
            path: `/paidServices/${serviceId}`,
            data,
        },
        id: serviceId,
        fields: data,
    };
}

export function getPaidServicesList(_, {offset, limit}) {
    return {
        type: GET_PAID_SERVICES_LIST,
        httpRequest: {
            method: 'get',
            path: 'paidServices',
            params: {
                offset,
                limit,
            },
        },
        offset,
        limit,
    };
}

export function getActivePaidServicesList() {
    return {
        type: GET_ACTIVE_PAID_SERVICES_LIST,
        httpRequest: {
            method: 'get',
            path: '/paidServices/active',
        },
    };
}

export function getPaidServicesForHomepage() {
    return {
        type: GET_PAID_SERVICES_FOR_HOME_PAGE,
        httpRequest: {
            method: 'get',
            path: '/paidServices/home',
        },
    };
}

export function activateService(serviceId) {
    return {
        type: ACTIVATE_SERVICE,
        httpRequest: {
            method: 'put',
            path: `/paidServices/activate/${serviceId}`,
        },
        id: serviceId,
        fields: {
            isActive: true,
        },
    };
}

export function deactivateService(serviceId) {
    return {
        type: DEACTIVATE_SERVICE,
        httpRequest: {
            method: 'put',
            path: `/paidServices/deactivate/${serviceId}`,
        },
        id: serviceId,
        fields: {
            isActive: false,
        },
    };
}

export function addToHomepage(serviceId) {
    return {
        type: ADD_TO_HOMEPAGE,
        httpRequest: {
            method: 'put',
            path: `/paidServices/${serviceId}/add-to-homepage`,
        },
        id: serviceId,
        fields: {
            isHomepageDisplayable: true,
        },
    };
}

export function removeFromHomepage(serviceId) {
    return {
        type: REMOVE_FROM_HOMEPAGE,
        httpRequest: {
            method: 'put',
            path: `/paidServices/${serviceId}/remove-from-homepage`,
        },
        id: serviceId,
        fields: {
            isHomepageDisplayable: false,
        },
    };
}

export function showCreatePaidServiceDialog() {
    return {
        type: extendActionType.show(CREATE_PAID_SERVICE_DIALOG),
    };
}

export function hideCreatePaidServiceDialog() {
    return {
        type: extendActionType.clean(CREATE_PAID_SERVICE_DIALOG),
    };
}

export function showEditPaidServiceDialog(paidService) {
    return {
        type: extendActionType.show(EDIT_PAID_SERVICE_DIALOG),
        paidService,
    };
}

export function hideEditPaidServiceDialog() {
    return {
        type: extendActionType.clean(EDIT_PAID_SERVICE_DIALOG),
    };
}

export function showRequestPaidServiceDialog(paidService) {
    return {
        type: extendActionType.show(REQUEST_PAID_SERVICE_DIALOG),
        paidService,
    };
}

export function hideRequestPaidServiceDialog() {
    return {
        type: extendActionType.clean(REQUEST_PAID_SERVICE_DIALOG),
    };
}



// WEBPACK FOOTER //
// ./src/reducers/paidServices/paidServiceActions.js